<template>
    <span>
        <template v-if="isNameDisplayed">
            <b>{{ location.name }}</b>
            <br />
        </template>
        {{ location.address }}
        <br />
        {{ location.city }},
        {{ location.state }}
        {{ location.zip }}
    </span>
</template>

<script>
    export default {
        props: {
            location: { type: Object, required: true },
            isNameDisplayed: { type: Boolean, default: false },
        },
    }
</script>
